<template>
  <div v-if="currentExperience == null">Loading</div>
  <div v-else class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0 d-flex justify-content-between">
            <div>
              <h3 class="card-title text-primary mb-0">Editar Experiencia</h3>
              <div class="sub-line"></div>
            </div>
          </div>
          <div class="card-body">
            <div class="col-sm mx-60">
                <experience-form :entity="currentExperience" action="update" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import ExperienceForm from "./ExperienceForm.vue";


    const store = useStore();
    const route = useRoute();


    const getCurrentExperience = async (id) => {
      return await store.dispatch("experience/getExperienceById", id);
    };

    const currentExperience = computed(() =>
    {
      if(!store.state.experience.currentExperience) return null
      let exp = store.state.experience.currentExperience
      if( exp.trail && exp.trail['@id']){
        exp.trail = exp.trail['@id']
      }
      if( exp.type && exp.type['@id']){
        exp.type = exp.type['@id']
      }

      return exp
    });

    onMounted(() => {
      getCurrentExperience(route.params.id)
    });



</script>
